module.exports = __webpack_public_path__ + "img/laft_bg5.48aa77fd.png";